import { Container, Text } from '@chakra-ui/react';
import { AxiosError } from 'axios';
import { NextPage } from 'next';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';
import { useToast } from '@/hooks/useToast';

import { PageTitle } from '@/components/PageTitle/PageTitle';
import { RemindPasswordForm } from '@/components/RemindPassword/RemindPasswordForm';
import { RemindPasswordSent } from '@/components/RemindPassword/RemindPasswordSent';
import Seo from '@/components/Seo';

import { AccountService } from '@/services/AccountService';

type RemindPasswordError = {
    code: string;
    location: string;
};

type RemindPasswordResponseError = {
    errors: RemindPasswordError[];
};

const RemindPassword: NextPage = () => {
    const [actionSuccessful, setActionSuccessful] = useState(false);
    const { errorToast } = useToast();
    const intl = useIntl();

    const remindPasswordFormSubmit = (memberEmail: string) => {
        AccountService.remindPassword(memberEmail)
            .then(() => {
                setActionSuccessful(() => true);
            })
            .catch((response: AxiosError<RemindPasswordResponseError>) => {
                const { errors } = response.response?.data || ({} as RemindPasswordResponseError);
                let errorMessage = intl.formatMessage({ id: 'password-cannot-be-reset' });

                if (errorMessage.length) {
                    errorMessage += `. ${intl.formatMessage({ id: errors?.[0].code })}`;
                }
                errorToast({
                    description: errorMessage
                });
            });
    };

    return (
        <>
            <Seo templateTitle={intl.formatMessage({ id: 'page.remind-password.title' })} />
            <Container as="section" maxW="site" py={10} my={6}>
                <PageTitle title={intl.formatMessage({ id: 'page.remind-password.title' })} />
                {!actionSuccessful ? (
                    <>
                        <Text mx="auto" mb={14} textAlign="center" fontSize="lg">
                            <FormattedMessage id="page.remind-password.description"></FormattedMessage>
                        </Text>
                        <RemindPasswordForm onSubmit={remindPasswordFormSubmit} />
                    </>
                ) : (
                    <RemindPasswordSent />
                )}
            </Container>
        </>
    );
};

export const getServerSideProps = withCommonServerSideProps(undefined, { requiresAuth: false });

export default RemindPassword;
